import { render, staticRenderFns } from "./V2AddressSection.vue?vue&type=template&id=4104ea7a&scoped=true&"
import script from "./V2AddressSection.vue?vue&type=script&lang=js&"
export * from "./V2AddressSection.vue?vue&type=script&lang=js&"
import style0 from "./V2AddressSection.vue?vue&type=style&index=0&id=4104ea7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4104ea7a",
  null
  
)

export default component.exports